export const BLOB_CONFIG = {
  "background": "#ffffff",
  "gradientMap": "25",
  "gradientColor1": "#ffffff",
  "gradientColor2": "#ffffff",
  "gradientColor3": "#ffffff",
  "uPositionFrequency": 0,
  "uPositionStrength": 0,
  "uSmallWavePositionFrequency": 0,
  "uSmallWavePositionStrength": 0.10999999999999999,
  "uSmallWaveTimeFrequency": 0.27,
  "uTimeFrequency": 0.21000000000000002,
  "roughness": 1,
  "metalness": 0.43,
  "envMapIntensity": 1,
  "clearcoat": 1,
  "clearcoatRoughness": 1,
  "transmission": 0.35000000000000003,
  "wireframe": false,
  "flatShading": false,
  "autoRotate": true,
  "autoRotateSpeed": 8.4
};